import React from 'react';
import Chart from 'react-apexcharts';

const HealthScoreSparkline = ({ data = [], width = 100, height = 40 }) => {
  // Handle empty or insufficient data
  if (!data || data.length === 0) {
    return (
      <div style={{ width, height }} className="flex items-center justify-center text-gray-400 text-xs">
        No data
      </div>
    );
  }

  // Show skeleton state for sparse data (< 5 data points)
  if (data.length < 5) {
    return (
      <div style={{ width, height }} className="flex items-center justify-center text-gray-400 text-xs">
        Limited data
      </div>
    );
  }

  const options = {
    chart: {
      type: 'line',
      sparkline: {
        enabled: true
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 400
      },
      events: {
        mouseMove: function() {
          return false;
        }
      }
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },
    colors: ['#10b981'],
    markers: {
      size: 0
    },
    tooltip: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
    grid: {
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    states: {
      hover: {
        filter: {
          type: 'none'
        }
      }
    }
  };

  const series = [{
    name: 'Health Score',
    data: data.map(d => ({
      x: new Date(d.date),
      y: d.score
    }))
  }];

  return (
    <div style={{ width, height }}>
      <Chart
        options={options}
        series={series}
        type="line"
        width={width}
        height={height}
      />
    </div>
  );
};

export default HealthScoreSparkline;

